module.exports = __webpack_public_path__ + "static/media/gear.b046d8de.svg";